import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Familiar() {
  const statements = ["I'm high-functioning and don't usually ask for help — but I'm starting to feel stuck.", 'I give my all to everyone else and neglect my own needs.', 'Everyone sees me as confident, but I struggle with self-doubt.', 'I feel lonely or misunderstood, like no one really "gets" me.', "I'm successful, but I often feel like an imposter."];
  return <section className="py-24 bg-accent-100" data-id="element-26" data-mp="28pwl4uq1z0ls">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27" data-mp="28olmf9bgsj1j">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-28" data-mp="1uqn7o2t8ekli">
          <div data-id="element-29" data-mp="1us85q2er8lo4">
            {/* Secondary portrait — swap src with Dr. Conkright's photo */}
            <div className="relative mb-8 max-w-sm" data-id="element-30" data-mp="1zrb9ljj00lui">
              <div className="aspect-square rounded-3xl overflow-hidden bg-brand-100 shadow-md" data-id="element-31" data-mp="jap248x9igp1">
                <img src="https://cdn.magicpatterns.com/uploads/c2JjpGwoc21H8vSMkmxJDi/DSC00640.jpg" alt="Dr. Scott Conkright at the piano" className="w-full h-full object-cover" data-id="element-32" data-mp="oabgilotu2zf" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-title font-bold mb-6" data-id="element-33" data-mp="11lw7s3ju9p5o">
              Does this sound familiar?
            </h2>
            <p className="text-stone-600 text-lg mb-8" data-id="element-34" data-mp="wlgrp486a3k0">
              Many of my clients come to me feeling successful on the outside,
              but struggling internally. You don't have to navigate these
              feelings alone.
            </p>
            <a href="#" className="inline-flex items-center px-6 py-3 bg-white text-stone-900 border border-stone-200 rounded-full font-medium hover:bg-stone-50 transition-colors" data-id="element-35" data-mp="1kbkx9h4x8ddn">
              Learn more about my approach
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-36" data-mp="1tag5eyrizxjl" />
            </a>
          </div>

          <div className="space-y-4" data-id="element-37" data-mp="1pcig7vxr9bg7">
            {statements.map((statement, index) => <div key={index} className="flex items-start p-6 bg-white rounded-2xl shadow-sm border border-stone-100" data-id="element-38" data-mp="1wfoy8jl05po1" data-mpi={index}>
                <CheckCircle2 className="h-6 w-6 text-brand-600 shrink-0 mt-0.5 mr-4" data-id="element-39" data-mp="26c1pzbwzltg5" />
                <p className="text-stone-700 font-medium leading-relaxed" data-id="element-40" data-mp="2b2ry2wwssaej">
                  {statement}
                </p>
              </div>)}

            <div className="pt-6 pl-4 border-l-2 border-brand-200 mt-8" data-id="element-41" data-mp="2f4dbqkh5osps">
              <p className="text-lg font-semibold text-stone-900" data-id="element-42" data-mp="2k2evz8qbiy2u">
                If any of this resonates, let's talk.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}